import { BiInfoCircle } from 'react-icons/bi';
import { HStack } from '../HStack';
import { Text } from '../Text';
import theme from '../../theme';

export const WarningBanner = ({
  text,
  children,
}: {
  text?: string;
  children?: React.ReactNode;
}) => {
  return (
    <HStack className='gap-2 rounded-[5px] border border-yellow-400 bg-yellow-100 px-3 py-2 '>
      <BiInfoCircle
        className='min-h-[20px] min-w-[20px]'
        size={20}
        color={theme.colors.yellow[800]}
      />
      {text ? <Text color={'yellow-800'}>{text}</Text> : children}
    </HStack>
  );
};
